import React, {Component} from 'react';
import PropTypes from "prop-types";

class PageLinksContainer extends Component {

    static propTypes = {
        pageLinks: PropTypes.array.isRequired,
    };

    static defaultProps = {
        pageNavigation: null,
        linkClasses: null,
        onClick: null,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.navigate = this.navigate.bind(this);

    }

    navigate(event, page) {

        event.preventDefault();

        if (page && this.props.pageNavigation) this.props.pageNavigation(page);
        if (page && this.props.onClick) this.props.onClick(event, page);

        return null;

    }

    renderLinks() {

        if (this.props.pageLinks) {
            const pageLinks = this.props.pageLinks;

            return pageLinks.map(
                (pageLink) => {
                    if (pageLink.header && pageLink.src && pageLink.link) {
                        let position = (pageLink.position) ? pageLink.position : null;
                        let classes = ['pageLinks', ((pageLink.classes) ? pageLink.classes : ''), ((this.props.linkClasses) ? this.props.linkClasses : ''), 'ma-bo-10'].join(' ').trim();
                        let src = (pageLink.src) ? <img src={pageLink.src} alt=""/> : null;
                        let body = (pageLink.body) ? pageLink.body : null;

                        return (
                            <div key={'link-' + pageLink.link} className={classes}>
                                <a className="pageLinkBox" onClick={(e) => this.navigate(e, pageLink.link)}>
                                    <div className="pageLinkHeader">
                                        <div className="pageLinkCounter">{position}</div>

                                        {src}

                                        <h4>{pageLink.header}</h4>
                                    </div>

                                    <div className="PageLinkBody">
                                        {body}
                                    </div>
                                </a>
                            </div>
                        );
                    }
                }
            );
        } else {
            return [];
        }

    }

    render() {

        const renderLinks = this.renderLinks();

        if (renderLinks.length === 0) return null;

        return (
            <div className="pageLinkContainer archivArea clearfix">
                <div className="col-xs-12">
                    {renderLinks}
                </div>
            </div>
        );

    }

}

export default PageLinksContainer;